import React, { useEffect, useLayoutEffect } from "react"
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

import AppStoreButton from "../appStoreButton/AppStoreButton"
import appIcon from "../../assets/brand/app-icon.png"

import styles from "./Nav.module.scss"

const Nav: React.FC = () => {
  useEffect(() => {
    ScrollTrigger.matchMedia({
      // Desktop
      "(min-width: 768px)": () => {
        // On scroll the nav bar will scale to the top
        gsap.fromTo(
          "#nav",
          {
            scale: 1.4,
          },
          {
            scale: 1,
            duration: 0.3,
            ease: "ease-in-out",
            scrollTrigger: {
              trigger: "#nav-container",
              start: "20px",
              toggleActions: "play none none reverse",
            },
          }
        )
      },
      // Mobile
      "(max-width: 767px)": () => {
        gsap.set("#nav", { scale: 1 })
      },
    })
  }, [])

  return (
    <nav id="nav-container" className={styles.container}>
      <div id="nav">
        <img src={appIcon} alt="Agile Coaching Cards" />
        <AppStoreButton isAppleStore={true} />
        <AppStoreButton isAppleStore={false} />
      </div>
    </nav>
  )
}

export default Nav
